import axios from 'axios';

import { BASE_API_URL, userService } from '../_services';
import { authHeader, router } from '../_helpers';
import { store } from '../_store/index';


function getClientConsultData(url) {
  return axios({
    method: 'get',
    url: BASE_API_URL + url,
    headers: authHeader()
  }).catch(handleResponse)
    .then(response => response.data)
}

function getSummaryReportSettings({ clientId, consultType }) {
  return axios({
    method: 'get',
    url: `${BASE_API_URL}/clients/${clientId}/reports/summary_settings/${consultType}/`,
    headers: authHeader(),
  })
    .catch(handleResponse)
    .then((response) => response.data)
}

function saveClientConsultData(data, url) {
  return axios({
    method: 'post',
    url: BASE_API_URL + url,
    headers: authHeader(),
    data: data,
  }).catch(handleResponse)
    .then(response => response.data)
}

function saveClientAllocationsData(clientId, season, data) {
  return axios({
    method: 'post',
    url: `${BASE_API_URL}/clients/${clientId}/winter_consult/drug_allocations/${season}/save`,
    headers: authHeader(),
    data: data,
  }).catch(handleResponse)
    .then(response => response.data)
}

function consultBackup(data, clientId) {
  return axios({
    method: 'post',
    url: `${BASE_API_URL}/clients/${clientId}/indexeddb/backup`,
    headers: authHeader(),
    data: data,
  }).catch(handleResponse)
    .then(response => response.data)
}

function errorTrack(data) {
  return axios({
    method: 'post',
    url: `${BASE_API_URL}/errors/backup/`,
    headers: authHeader(),
    data: data,
  }).catch(handleResponse)
    .then(response => response.data)
}

function getErrors() {
  return axios({
    method: 'get',
    url: `${BASE_API_URL}/errors/backup/`,
    headers: authHeader()
  }).catch(handleResponse)
    .then(response => response.data)
}

function getError(id) {
  return axios({
    method: 'get',
    url: `${BASE_API_URL}/errors/backup/${id}/`,
    headers: authHeader()
  }).catch(handleResponse)
    .then(response => response.data)
}

function handleResponse(error) {
  if (error.response.status == 401) {
    store.dispatch('alert/error', { message: 'Your session has expired.' }, { root: true });
    userService.logout()
    router.push('/login')
  } else if (error.response.status == 403) {
    store.dispatch('alert/error', { message: 'Your vet user code has not been set in EzyVet please see Keyvet admin' }, { root: true });
  }
  return Promise.reject(error)
}

function sendRegulationEmail(data) {
  return axios({
    method: 'post',
    url: BASE_API_URL + `/clients/${data.client_id}/dry_cow_consult/${data.season}/regulation_email`,
    headers: authHeader(),
    data: data,
  }).catch(handleResponse)
    .then(response => response.data)
}

export const consultFormService = {
  consultBackup,
  errorTrack,
  getClientConsultData,
  getError,
  getErrors,
  getSummaryReportSettings,
  saveClientAllocationsData,
  saveClientConsultData,
  sendRegulationEmail,
};
